export default {
  title: 'Ravencoin (Volunteer Project)',
  title_ja: 'Ravencoin（ボランティアプロジェクト）',
  title_zh: 'Ravencoin（志愿项目）',
  
  role: 'Community Moderator',
  role_ja: 'コミュニティモデレーター',
  role_zh: '社区版主',
  
  location: 'Remote',
  location_ja: 'リモート',
  location_zh: '远程',
  
  period: 'Jan 2018 – 2021',
  
  slug: 'ravencoin',
  
  summary: 'Founded and managed the Chinese RVN community, promoting Ravencoin\'s growth and blockchain education in Chinese-speaking regions.',
  summary_ja: '中国のRVNコミュニティを設立・管理し、中国語圏でのRavencoinの成長とブロックチェーン教育を促進しました。',
  summary_zh: '创建并管理中文RVN社区，促进Ravencoin在中文地区的发展和区块链教育。',
  
  achievements: [
    'Founded and managed the Chinese RVN community',
    'Engaged in cross-cultural communication for over 2 years across Discord, Telegram, and other platforms',
    'Coordinated with the iOS developer Roshii on Chinese UI translation and app testing',
    'Translated official announcements and news for the Chinese-speaking audience',
    'Moderated a 1,400+ member QQ group, supported community engagement and event localization',
    'Bridged communication between Chinese Nvidia-based mining operators and overseas buyers'
  ],
  
  achievements_ja: [
    '中国のRVNコミュニティを設立・管理',
    'Discord、Telegram、その他のプラットフォームで2年以上にわたり異文化間コミュニケーションに携わる',
    'iOSデベロッパーのRoshiiと中国語UIの翻訳とアプリのテストで協力',
    '中国語圏のオーディエンス向けに公式発表やニュースを翻訳',
    '1,400人以上のメンバーを持つQQグループをモデレート、コミュニティの関与とイベントのローカライズをサポート',
    '中国のNVIDIAベースのマイニング事業者と海外バイヤーとのコミュニケーションを橋渡し'
  ],
  
  achievements_zh: [
    '创建并管理中文RVN社区',
    '在Discord、Telegram和其他平台上进行了2年多的跨文化交流',
    '与iOS开发者Roshii合作进行中文UI翻译和应用测试',
    '为中文用户翻译官方公告和新闻',
    '管理1,400多人的QQ群，支持社区参与和活动本地化',
    '搭建中国Nvidia矿机运营商与海外买家之间的沟通桥梁'
  ],
  
  tags: ['blockchain', 'community', 'volunteer', 'translation'],
  
  metadata: {
    type: 'Volunteer Project',
    type_ja: 'ボランティアプロジェクト',
    type_zh: '志愿项目',
    
    field: 'Blockchain',
    field_ja: 'ブロックチェーン',
    field_zh: '区块链',
    
    teamSize: 'Community-based',
    teamSize_ja: 'コミュニティベース',
    teamSize_zh: '社区为基础',
    
    role: 'Community Moderator',
    role_ja: 'コミュニティモデレーター',
    role_zh: '社区版主'
  },
  
  // For future detailed content
  getContent: () => import('../content/ravencoin.md')
} 